import { Divider, Grid, Stack,Box, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import React from 'react';
import { useGetProformaDetails } from '../../api/hooks/sales';
import { toPersianDate, toPersianNumber, toPersianNumberString } from '../../utils/helpers';
import Table from '../common/table';
// import { Tooltip } from '@mui/material';

export default function Proforma({ id }) {
  const { data: proforma } = useGetProformaDetails(id);
  document.title =
    proforma?.status === 'COMPLETED'
      ? `فاکتور ${proforma?.number}`
      : `پیش‌فاکتور ${proforma?.number}`;
  const paymentDestinations = proforma?.paymentDestinations
    ?.map(
      (destination) =>
        `شماره شبای IR-${destination.shebaNumber.substring(0, 2)}-` +
        `${destination.shebaNumber.substring(2, 6)}-` +
        `${destination.shebaNumber.substring(6, 10)}-` +
        `${destination.shebaNumber.substring(10, 14)}-` +
        `${destination.shebaNumber.substring(14, 18)}-` +
        `${destination.shebaNumber.substring(18, 22)}-` +
        `${destination.shebaNumber.substring(22, 26)}` +
        `${destination.shebaNumber.substring(26, 30)}` +
        `${destination.shebaNumber.substring(30, 32)}` +
        ` بانک ${destination.bank}` +
        ` به نام شرکت ${proforma.seller.name}`
    )
    .join(' یا ');

  return (
    <Paper variant="outlined" sx={{ width: '95%', mx: 'auto' }}>
      <Grid container sx={{ p: 3 }} spacing={2}>
        <Grid item xs={8}>
          <Typography fontSize={24} fontWeight={600}>
            {proforma.status === 'COMPLETED'
              ? 'فاکتور فروش کالا و خدمات'
              : 'پیش‌فاکتور فروش کالا و خدمات'}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Stack direction="row" justifyContent="space-between">
            <Typography>شماره</Typography>
            <Typography fontWeight={600}>{toPersianNumberString(proforma?.number)}</Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography>تاریخ صدور</Typography>
            <Typography fontWeight={600}>{toPersianDate(proforma?.createdAt)}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Typography fontSize={20} lineHeight={2} fontWeight={500}>
            فروشنده
          </Typography>
          <Grid container sx={{ px: 2 }} columnSpacing={2} rowSpacing={0.5}>
            {fields.map((f) => (
              <Grid item xs={12} key={f.name}>
                <Stack direction="row" justifyContent="space-between">
                  <Typography lineHeight={1} fontWeight={600} fontSize={12}>
                    {f.display}:
                  </Typography>
                  <Typography fontSize={12} sx={{ pl: 3 }} textAlign="justify">
                    {toPersianNumberString(proforma?.seller?.[f.name])}
                  </Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Divider orientation="vertical" flexItem style={{ marginRight: '-1px' }} />
        <Grid item xs={6}>
          <Typography fontSize={20} lineHeight={2} fontWeight={500}>
            خریدار
          </Typography>
          <Grid container sx={{ px: 2 }} columnSpacing={2} rowSpacing={0.5}>
            {fields.map((f) => (
              <Grid item xs={12} key={f.name}>
                <Stack direction="row" justifyContent="space-between">
                  <Typography lineHeight={1} fontWeight={600} fontSize={12}>
                    {f.display}:
                  </Typography>
                  <Typography fontSize={12} sx={{ pl: 3 }} textAlign="justify">
                    {toPersianNumberString(proforma?.buyer?.[f.name])}
                  </Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid xs={12} sx={{ pt: 2, px: 1 }}>
          <Table
            columns={columns(proforma?.discount)}
            rows={processRows(proforma?.rows, proforma?.discount)}
            cellSx={{ fontSize: '12px', py: 1 }}
          />
        </Grid>

        <Grid xs={12} sx={{ p: 1 }}>
          <Typography fontWeight={600} sx={{ display: 'inline', px: 2 }}>
            توضیحات:
          </Typography>
          <ul>
            {proforma.status !== 'COMPLETED' && (
              <li>
                <Typography sx={{ pl: 4 }}>
                  لطفا وجه فاکتور را به {paymentDestinations} واریز نمایید.
                </Typography>
              </li>
            )}
            {proforma?.details && (
              <li>
                <Typography sx={{ pl: 4 }}>{proforma?.details}</Typography>
              </li>
            )}
          </ul>
        </Grid>
        <Grid xs={6} sx={{ px: 3, height: '100px' }}>
          <Stack direction="row" justifyContent="space-between">
            <Typography fontSize={16} lineHeight={4} fontWeight={500}>
              امضا فروشنده
            </Typography>
            <Box sx={{ pt: 2 }}>
              <img src={`/${proforma?.seller?.id ?? 3}-sign.jpg`} height="80px" />
            </Box>
          </Stack>
        </Grid>
        <Grid xs={6} sx={{ px: 3, height: '100px' }}>
          <Typography fontSize={16} lineHeight={4} fontWeight={500}>
            امضا خریدار
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

const fields = [
  { name: 'name', display: 'نام' },
  { name: 'nationalId', display: 'شناسه‌ملی' },
  { name: 'ecoId', display: 'کد اقتصادی' },
  { name: 'phoneNumber', display: 'شماره‌تلفن' },
  { name: 'postalCode', display: 'کد پستی' },
  { name: 'address', display: 'آدرس' },
];

const columns = (discount) => [
  {
    id: 'model',
    label: 'مدل‌ کالا',
    minWidth: 160,
    format: (m) =>
      m?.name
        ? `گوشی ${m?.name} (${m?.memory}/${m?.ram})`
        : `جمع (تخفیف:  ${toPersianNumber(discount)} ریال)`,
  },
  { id: 'color', label: 'رنگ', minWidth: 50, format: (c) => c?.name },
  { id: 'amount', label: 'تعداد', minWidth: 50, format: toPersianNumber },
  {
    id: 'unitPrice',
    label: 'قیمت واحد (ریال)',
    minWidth: 70,
    format: (x) => (x ? toPersianNumber(x, true) : ''),
  },
  {
    id: 'totalPrice',
    label: 'قیمت کل (ریال)',
    minWidth: 70,
    format: (x) => toPersianNumber(x, true),
  },
  {
    id: 'totalPriceWithTax',
    label: 'قیمت کل +‌مالیات (ریال)',
    minWidth: 70,
    format: (x) => toPersianNumber(Math.round(x), true),
  },
];

function processRows(rows, discount) {
  if (!rows) return [];
  const r = rows?.map((r) => ({
    ...r,
    totalPrice: r.amount * r.unitPrice,
    totalPriceWithTax: r.amount * r.unitPrice * 1.10,
  }));
  const agg = aggregateData(r, discount);
  return [...r, agg];
}

function aggregateData(rows, discount) {
  const totalPrice = Math.floor(rows?.reduce((p, c) => p + c.totalPrice, 0));
  const amount = rows?.reduce((p, c) => p + Number(c.amount), 0);
  const totalPriceWithTax =
    Math.floor(rows?.reduce((p, c) => p + Number(c.totalPriceWithTax), 0)) - discount;
  return { totalPrice, amount, totalPriceWithTax };
}
